import {useEffect} from "react";
import {useAuth} from "../../contexts/auth";

export default function LogoutPage() {
	const { signOut } = useAuth();

	useEffect(() => { signOut(true); });

	return (<></>);
}
